import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	accordion: {
		...ColorUtil.getBackgroundAndContrastColor("transparent"),
		boxShadow: "none"
	},
	accordionSummary: {
		padding: 0
	},
	accordionSummaryText: {
		fontSize: 16,
		fontWeight: 500,
		color: colors.purple[600]
	},
	accordionSummaryIcon: {
		color: colors.purple[600]
	},
	accordionDetails: {
		padding: 0
	}
})

export default useStyles
